import React from 'react';

class Goals extends React.Component {
  render() {
    return (
      <div className="app">
        <h1 className="app-heading color-yellow">Goals</h1>
        <p className="app-paragraph">Things I want to do before I die.</p>
      </div>
    );
  }
}

export default Goals;



// WEBPACK FOOTER //
// ./src/Pages/Goals.js